import axios from 'axios'

const RESOURCE_NAME = '/locations'

export default {

  delete (id) {
    return axios.delete(`${RESOURCE_NAME}/${id}`)
  }

}
